module.exports = __webpack_public_path__ + "static/media/MBlair_resume.2c64ef27.pdf";